import { useLoaderData } from 'react-router';

import type { TravelConfidenceMapProps } from '@web-platform/travel-tools-flight-price-map-types/src/travel-confidence-map-props';

export const useTravelConfidenceMap = () => useLoaderData<TravelConfidenceMapProps>();

export const useDestinations = () => useTravelConfidenceMap().confidenceMapData?.destinations || [];

export const useOriginContext = () => useTravelConfidenceMap().confidenceMapData?.originContext;

export const useSummary = () => useTravelConfidenceMap().confidenceMapData?.summary;

export const useTotalCount = () => useTravelConfidenceMap().confidenceMapData?.totalCount;

export const useOriginCityEntityId = () => useTravelConfidenceMap().originCityEntityId;

export const useUrlCountryName = () => useTravelConfidenceMap().urlCountryName;
